import { Component, CUSTOM_ELEMENTS_SCHEMA,EventEmitter,Output, Input } from "@angular/core";
import { CommonService } from "../../services/common.service";
import { Subscription, finalize, tap } from "rxjs";
import { Router } from "@angular/router";
import { ApiService } from "../../services/api.service";
import {
  SidebarModule,
  NavModule,
  GridModule,
  HeaderModule,
  CardModule,
  AvatarModule,
  DropdownModule,
} from "@coreui/angular";
import { IconModule } from "@coreui/icons-angular";
import { freeSet } from "@coreui/icons";
import { CommonModule } from "@angular/common";
import { STATIC_KEYS } from "src/constants/constants";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [
    SidebarModule,
    NavModule,
    GridModule,
    IconModule,
    HeaderModule,
    CardModule,
    AvatarModule,
    DropdownModule,
    CommonModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
  private subscriptions: Subscription[] = [];
  loggedInUserInfo: any;
  isWebView!: boolean;
  @Input() sidebarId: string = "sidebar";
  icons = freeSet;
  @Output() toggleSidebarEvent = new EventEmitter<void>();
  @Input() sidebarCollapsed = false;
  constructor(
    private commonService: CommonService,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.isWebView = this.commonService.isWebView();
    this.loggedInUserInfo = this.commonService.getItem(
      STATIC_KEYS.LOGGED_IN_USER_INFO,
      true
    );
  }

  toggleSidebar() {
    this.toggleSidebarEvent.emit();
  }
  logoutBtnClicked() {
    this.subscriptions.push(
      this.apiService
        .logout()
        .pipe(
          tap({
            error: () => {
              this.handleLogout();
            },
          }),
          finalize(() => this.handleLogout())
        )
        .subscribe()
    );
  }

  private handleLogout() {
    this.commonService.clearLocalStorage();
    this.router.navigateByUrl("/login");
  }

  resetPassword() {
    this.router.navigateByUrl("/admin/reset-password");
  }

  myProfileRedirect() {
    this.router.navigateByUrl("/admin/my-profile");
  }

  onImageAvtrError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    console.log(imgElement);
    
    imgElement.src = "assets/images/avatar.jpg";
  }
}
